const NAMES = { sunday: 0, sun: 0, monday: 1, mon: 1, tuesday: 2, tue: 2, tues: 2, wednesday: 3, wed: 3, thursday: 4, thu: 4, thur: 4, thurs: 4, friday: 5, fri: 5, saturday: 6, sat: 6 };
const DAY_LABEL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const daysForLabel = (label) => {
  const l = (label || "").toLowerCase();
  const parts = l.split(/[-–—]/).map((s) => s.replace(/[^a-z]/g, ""));
  if (parts.length === 2 && NAMES[parts[0]] != null && NAMES[parts[1]] != null) {
    const a = NAMES[parts[0]], b = NAMES[parts[1]];
    const out = [];
    for (let d = a; ; d = (d + 1) % 7) { out.push(d); if (d === b) break; if (out.length > 7) break; }
    return out;
  }
  const single = NAMES[l.replace(/[^a-z]/g, "")];
  return single != null ? [single] : [];
};

const parseTime = (t) => {
  const m = (t || "").trim().match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)?/i);
  if (!m) return null;
  let h = +m[1];
  const min = m[2] ? +m[2] : 0;
  const ap = m[3] ? m[3].toUpperCase() : null;
  if (ap === "PM" && h !== 12) h += 12;
  if (ap === "AM" && h === 12) h = 0;
  return h * 60 + min;
};

const nowInET = () => {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", weekday: "long", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const day = NAMES[(get("weekday") || "").toLowerCase()] ?? new Date().getDay();
  let hour = parseInt(get("hour"), 10);
  if (hour === 24) hour = 0;
  const minute = parseInt(get("minute"), 10);
  return { day, minutes: hour * 60 + minute };
};

export const getTodayStatus = (hours) => {
  const { day, minutes } = nowInET();
  const entry = (hours || []).find((h) => daysForLabel(h.day).includes(day));
  if (!entry) return { isOpen: false, todayTime: null, todayLabel: DAY_LABEL[day] };
  const [openStr, closeStr] = (entry.time || "").split(/[-–—]/);
  const open = parseTime(openStr);
  const close = parseTime(closeStr);
  const isOpen = open != null && close != null && minutes >= open && minutes < close;
  return { isOpen, todayTime: entry.time, todayLabel: DAY_LABEL[day] };
};
